// Стабильные коды и подписи для демо МезоРеал.
// Основной источник подписей — API (/analytics/calls/filter-options); здесь только
// значения, которые нужны фронту до загрузки данных или для служебных фильтров.

export const INTENT_LABELS = {
  new_lead: 'Новая заявка',
  confirmation: 'Подтверждение',
  followup_or_reactivation: 'Дожим/реактивация',
  sale_or_order: 'Покупка',
  support_or_question: 'Вопрос/поддержка',
  no_answer_or_technical: 'Недозвон или технический звонок',
  request_info: 'Запрос информации',
  confirm_attendance: 'Подтверждение участия',
  enroll_training: 'Запись на обучение',
  buy_products: 'Покупка продуктов',
  confirm_order: 'Подтверждение покупки',
  ask_price: 'Вопрос о цене',
  choose_program: 'Выбор программы',
  discuss_individual_training: 'Индивидуальное обучение',
  complaint: 'Жалоба',
  existing_booking_or_order: 'Существующая заявка',
  followup: 'Повторный контакт',
  sales_outbound: 'Продажный обзвон',
  information_request: 'Информационный запрос',
  new_request: 'Новый запрос',
  problem_resolution: 'Решение проблемы',
  website_order: 'Покупка с сайта',
  test_ride: 'Тест-райд',
  preorder: 'Предварительная покупка',
  rental_or_booking: 'Аренда/бронь',
  service_or_repair: 'Сервис/ремонт',
  usage_consultation: 'Консультация по эксплуатации',
  logistics_or_delivery: 'Логистика/доставка',
  access_or_pass: 'Пропуск/доступ',
  payment_or_documents: 'Оплата/документы',
  internal_or_partner: 'Внутренний/партнерский звонок',
  target_client: 'Целевой клиент',
  existing_guest_service: 'Сервис проживающего гостя',
  internal_operations: 'Внутренние операции',
  b2b_documents: 'B2B / документы',
  hr_candidate: 'Кандидат / персонал',
  vendor_spam: 'Рекламный или продающий звонок',
  availability_booking: 'Наличие мест / бронь',
  course_price: 'Стоимость курса / путевки',
  treatment_consultation: 'Лечение и процедуры',
  hotel_accommodation: 'Гостиничное размещение',
  certificate_documents: 'Справки и документы',
  existing_booking_change: 'Изменение или отмена записи',
  guest_service_request: 'Сервис проживающего гостя',
  b2b_admin: 'B2B / административное',
  hr_staffing: 'Трудоустройство',
  vendor_offer: 'Коммерческое предложение',
  technical: 'Технический звонок',
  appointment_or_consultation: 'Запись или консультация',
  existing_appointment: 'Существующая запись',
  care_after_procedure: 'Звонок заботы',
  post_procedure_follow_up: 'Контроль после процедуры',
  complaint_or_negative: 'Жалоба',
  other_meaningful: 'Другое содержательное',
  irrelevant_or_technical: 'Нерелевантный/технический',
  new_booking_request: 'Новый запрос на запись',
  existing_booking_confirmation: 'Подтверждение записи',
  service_information: 'Справочный звонок',
  administrative_document_request: 'Документы и справки',
  complaint_handling: 'Обработка жалобы',
  other_relevant: 'Другое релевантное',
  other: 'Другое'
};

export const INTENT_COLORS = {
  new_lead: '#2563eb',
  confirmation: '#16a34a',
  followup_or_reactivation: '#f59e0b',
  sale_or_order: '#0ea5e9',
  support_or_question: '#14b8a6',
  no_answer_or_technical: '#64748b',
  request_info: '#2563eb',
  confirm_attendance: '#16a34a',
  enroll_training: '#22c55e',
  buy_products: '#0ea5e9',
  confirm_order: '#0891b2',
  ask_price: '#f59e0b',
  choose_program: '#7c3aed',
  discuss_individual_training: '#a855f7',
  complaint: '#ef4444',
  existing_booking_or_order: '#0891b2',
  followup: '#f59e0b',
  sales_outbound: '#0f766e',
  information_request: '#2563eb',
  new_request: '#16a34a',
  problem_resolution: '#ef4444',
  website_order: '#2563eb',
  test_ride: '#7c3aed',
  preorder: '#0891b2',
  rental_or_booking: '#0ea5e9',
  service_or_repair: '#ef4444',
  usage_consultation: '#14b8a6',
  logistics_or_delivery: '#f59e0b',
  access_or_pass: '#64748b',
  payment_or_documents: '#16a34a',
  internal_or_partner: '#475569',
  target_client: '#2563eb',
  existing_guest_service: '#14b8a6',
  internal_operations: '#64748b',
  b2b_documents: '#7c3aed',
  hr_candidate: '#a855f7',
  vendor_spam: '#ef4444',
  availability_booking: '#2563eb',
  course_price: '#f59e0b',
  treatment_consultation: '#16a34a',
  hotel_accommodation: '#0ea5e9',
  certificate_documents: '#7c3aed',
  existing_booking_change: '#0891b2',
  guest_service_request: '#14b8a6',
  b2b_admin: '#64748b',
  hr_staffing: '#a855f7',
  vendor_offer: '#ef4444',
  technical: '#64748b',
  appointment_or_consultation: '#2563eb',
  existing_appointment: '#0ea5e9',
  care_after_procedure: '#16a34a',
  complaint_or_negative: '#ef4444',
  other_meaningful: '#7c3aed',
  irrelevant_or_technical: '#64748b',
  new_booking_request: '#2563eb',
  existing_booking_confirmation: '#16a34a',
  service_information: '#0ea5e9',
  administrative_document_request: '#7c3aed',
  complaint_handling: '#ef4444',
  other_relevant: '#64748b',
  other: '#7c3aed',
  __unknown: '#94a3b8'
};

export const CALL_TYPE_OPTIONS = [
  { code: 'all', label: 'Все звонки' },
  { code: 'training_center', label: 'Учебный центр' },
  { code: 'product_sales', label: 'Продукты' },
  { code: 'clinic_patient', label: 'Клиника' },
  { code: 'incoming', label: 'Входящие' },
  { code: 'outgoing', label: 'Исходящие' },
  { code: 'no_answer_or_technical', label: 'Недозвон или технический звонок' },
  { code: 'unknown', label: 'Не определено' }
];

export const ELECTROBIKE_CALL_TYPE_OPTIONS = [
  { code: 'all', label: 'Все звонки' },
  { code: 'incoming', label: 'Входящие' },
  { code: 'outgoing', label: 'Исходящие' }
];

export const BELY_MEDVED_CALL_TYPE_OPTIONS = [
  { code: 'all', label: 'Все звонки' },
  { code: 'target_client', label: 'Целевые клиенты' },
  { code: 'existing_guest_service', label: 'Сервис гостей' },
  { code: 'internal_operations', label: 'Внутренние операции' },
  { code: 'no_answer_or_technical', label: 'Недозвон или технический звонок' },
  { code: 'b2b_documents', label: 'B2B / документы' },
  { code: 'hr_candidate', label: 'Кандидаты / персонал' },
  { code: 'vendor_spam', label: 'Реклама / продажи нам' }
];

export const DENTAL_DEPO_CALL_TYPE_OPTIONS = [
  { code: 'all', label: 'Все звонки' },
  { code: 'appointment_or_consultation', label: 'Запись или консультация' },
  { code: 'existing_appointment', label: 'Существующая запись' },
  { code: 'care_after_procedure', label: 'Звонок заботы' },
  { code: 'complaint_or_negative', label: 'Жалоба' },
  { code: 'other_meaningful', label: 'Другое содержательное' },
  { code: 'irrelevant_or_technical', label: 'Нерелевантный/технический' }
];

export const PLUS_CALL_TYPE_OPTIONS = [
  { code: 'all', label: 'Все звонки' },
  { code: 'new_booking_request', label: 'Новый запрос на запись' },
  { code: 'existing_booking_change', label: 'Изменение или отмена записи' },
  { code: 'existing_booking_confirmation', label: 'Подтверждение записи' },
  { code: 'service_information', label: 'Справочный звонок' },
  { code: 'administrative_document_request', label: 'Документы и справки' },
  { code: 'post_procedure_follow_up', label: 'Контроль после процедуры' },
  { code: 'other_relevant', label: 'Другое релевантное' },
  { code: 'no_answer_or_technical', label: 'Недозвон или технический звонок' }
];

export const getCallTypeOptionsForTenant = (tenantId) => {
  const normalizedTenant = tenantId?.trim?.().toLowerCase?.();
  if (normalizedTenant === 'electrobike') return ELECTROBIKE_CALL_TYPE_OPTIONS;
  if (normalizedTenant === 'bely_medved') return BELY_MEDVED_CALL_TYPE_OPTIONS;
  if (normalizedTenant === 'dental_depo') return DENTAL_DEPO_CALL_TYPE_OPTIONS;
  if (normalizedTenant === 'plus') return PLUS_CALL_TYPE_OPTIONS;
  return CALL_TYPE_OPTIONS;
};

export const CALL_TYPE_LABELS = CALL_TYPE_OPTIONS.reduce((acc, option) => {
  acc[option.code] = option.label;
  return acc;
}, PLUS_CALL_TYPE_OPTIONS.reduce((acc, option) => {
  acc[option.code] = option.label;
  return acc;
}, DENTAL_DEPO_CALL_TYPE_OPTIONS.reduce((acc, option) => {
  acc[option.code] = option.label;
  return acc;
}, BELY_MEDVED_CALL_TYPE_OPTIONS.reduce((acc, option) => {
  acc[option.code] = option.label;
  return acc;
}, ELECTROBIKE_CALL_TYPE_OPTIONS.reduce((acc, option) => {
  acc[option.code] = option.label;
  return acc;
}, {})))));

export const SERVICE_AREA_LABELS = {
  contour_plastic: 'Контурная пластика',
  mesotherapy: 'Мезотерапия',
  biorevitalization: 'Биоревитализация',
  peels: 'Пилинги',
  botox: 'Ботокс',
  hardware: 'Аппаратные методики',
  documents: 'Документы/медобразование',
  full_face: 'Full Face',
  orbital_zone: 'Орбитальная зона',
  schedule: 'Расписание',
  price_discount: 'Цена/скидка',
  product_advice: 'Консультация по продуктам',
  order: 'Покупка',
  website_order: 'Покупка с сайта',
  test_ride: 'Тест-райд',
  preorder: 'Предварительная покупка',
  rental_or_booking: 'Аренда/бронь',
  service_or_repair: 'Сервис/ремонт',
  usage_consultation: 'Консультация по эксплуатации',
  logistics_or_delivery: 'Логистика/доставка',
  access_or_pass: 'Пропуск/доступ',
  payment_or_documents: 'Оплата/документы',
  internal_or_partner: 'Внутренний/партнерский звонок',
  availability_booking: 'Наличие мест / бронь',
  course_price: 'Стоимость курса / путевки',
  treatment_consultation: 'Лечение и процедуры',
  hotel_accommodation: 'Гостиничное размещение',
  certificate_documents: 'Справки и документы',
  existing_booking_change: 'Изменение или отмена записи',
  guest_service_request: 'Сервис проживающего гостя',
  b2b_admin: 'B2B / административное',
  hr_staffing: 'Трудоустройство',
  vendor_offer: 'Коммерческое предложение',
  technical: 'Технический звонок',
  appointment_or_consultation: 'Запись или консультация',
  existing_appointment: 'Существующая запись',
  care_after_procedure: 'Звонок заботы',
  complaint_or_negative: 'Жалоба',
  other_meaningful: 'Другое содержательное',
  irrelevant_or_technical: 'Нерелевантный/технический',
  no_answer_or_technical: 'Недозвон или технический звонок',
  pediatrician_visit: 'Приём педиатра',
  specialist_visit: 'Приём профильного специалиста',
  diagnostics_uzi_xray: 'Диагностика: УЗИ и рентген',
  vaccination_mantoux: 'Вакцинация и проба Манту',
  lab_tests: 'Лабораторные анализы',
  medical_commission_card: 'Медицинская карта и комиссии',
  documents_certificates: 'Справки и документы',
  appointment_details: 'Детали записи',
  price_payment: 'Стоимость и оплата',
  branch_doctor_schedule: 'Филиал, врач и расписание',
  other_topic: 'Другая медицинская тема',
  other: 'Другое',
  unknown: 'Не определено',
  not_applicable: 'Не применимо'
};

export const QUALITY_FORMS = [
  { code: 'sales_full_checklist', label: 'Продажный чек-лист' },
  { code: 'bm_quality_checklist', label: 'Качество клиентского звонка' },
  { code: 'short_limited', label: 'Короткая консультация' },
  { code: 'logistics_limited', label: 'Логистика' },
  { code: 'technical_service_checklist', label: 'ТО/техподдержка' }
];

export const DENTAL_DEPO_QUALITY_FORMS = [
  { code: 'full_booking_checklist', label: 'Чек-лист записи и консультации' },
  { code: 'limited_quality_checklist', label: 'Ограниченный чек-лист сервиса' },
  { code: 'care_call_checklist', label: 'Чек-лист звонка заботы' }
];

export const PLUS_QUALITY_FORMS = [
  { code: 'plus_quality_checklist', label: 'Чек-лист качества' }
];

export const QUALITY_FORM_LABELS = DENTAL_DEPO_QUALITY_FORMS.reduce((acc, form) => {
  acc[form.code] = form.label;
  return acc;
}, PLUS_QUALITY_FORMS.reduce((acc, form) => {
  acc[form.code] = form.label;
  return acc;
}, QUALITY_FORMS.reduce((acc, form) => {
  acc[form.code] = form.label;
  return acc;
}, {})));

export const getQualityFormsForTenant = (tenantId) => {
  const normalizedTenant = tenantId?.trim?.().toLowerCase?.();
  if (normalizedTenant === 'bely_medved') {
    return QUALITY_FORMS.filter((form) => form.code === 'bm_quality_checklist');
  }
  if (normalizedTenant === 'dental_depo') return DENTAL_DEPO_QUALITY_FORMS;
  if (normalizedTenant === 'plus') return PLUS_QUALITY_FORMS;
  return QUALITY_FORMS;
};

export const FUNNEL_STAGE_LABELS = {
  applicable: 'Целевое действие применимо',
  attempt: 'Была попытка довести до результата',
  success: 'Запись на прием подтверждена',
  refusal: 'Отказ или зависло',
  interest_identified: 'Интерес выявлен',
  consultation_provided: 'Консультация проведена',
  appointment_option_offered: 'Предложено время записи',
  callback_or_message_planned: 'Запланирован следующий контакт',
  appointment_booked: 'Запись создана',
  dental_consulted_or_better: 'Потребность разобрана',
  dental_next_step_or_booking: 'Есть переход к записи'
};

export const CALLS_METRIC_OPTIONS = [
  { code: 'calls', label: 'Все звонки' },
  { code: 'applicable', label: 'Применимые' },
  { code: 'attempts', label: 'Попытки результата' },
  { code: 'bookings', label: 'Достигнуто' }
];

// Код возражения «Дорого» — по брифу выделяется отдельным акцентным цветом.
export const EXPENSIVE_OBJECTION_CODE = 'expensive';
